import request from '@/utils/request'
// 开始答题-获取第一道题目
export function getQuestion() {
    return request({
        method: 'POST',
        url: `/answer/getQuestion`,
      
    })
}
// 提交答案-并返回下一道题目
export function answering(data) {
    return request({
        method: 'POST',
        url: `/answer/answering`,
      data
    })
}